export default "__VITE_ASSET__5StkdeYy__"